

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      return config;
    },
    err => {
      Promise.reject(err)
    }
  );

  axios.interceptors.response.use(function (response) {
    return response;
    }, function (error) {
    //unauthorize access incase token has been expired 
    var accessDenied = error.toString().indexOf("401");
    if (accessDenied !== -1) {
      return window.location.href = '/logout'
    }
    return Promise.reject(error);
});

  
}
